import { render, staticRenderFns } from "./TinyBouncer.vue?vue&type=template&id=b0018e4c&"
import script from "./TinyBouncer.vue?vue&type=script&lang=js&"
export * from "./TinyBouncer.vue?vue&type=script&lang=js&"
import style0 from "./TinyBouncer.vue?vue&type=style&index=0&id=b0018e4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports